export default __webpack_public_path__ + "static/media/CocoaBean2Chocolate_03.f67abaf4.png";